module.exports = __webpack_public_path__ + "img/login-screen.b0e50378.jpg";